<div class="filter-container wrapper" id="filter-container">

  <div class="ui-m-1 filter-container-left-side">
    <i class="topbar-icon material-icons clickable" title="Fechar e limpar filtros" (click)="fecharELimparFiltros()">close</i>
  </div>

  <div class="ui-g-11 itens-filtro">
    <!-- FORM EXTRA ACTIONS -->
    <div class="ui-g">

      <ng-template ngFor let-item [ngForOf]="filtros">

        <div class="ui-g-1 item-filtro" *ngIf="!item.filterDataType">
          <span class="md-inputfield">
            <label style='color: red;'>{{item.fieldName}} :: ERROR</label>
          </span>
        </div>

        <!--
          *********************************
          TEXTO
          *********************************
        -->
        <div class="ui-g-1 item-filtro" *ngIf="item.filterDataType === 'TEXTO'">
          <span class="md-inputfield">
            <input
              type="text"
              [id]="item.fieldId"
              name="item.fieldId"
              [(ngModel)]="item.itemSelected"
              class="full-width"
              [disabled]="!!item.disabled"
              (onChange)="textoOnChange($event, item, filtros)"
              (keyup.enter)="textoOnChange($event, item, filtros)"
              pInputText>
            <label>{{item.fieldName}}</label>
          </span>
        </div>

        <!--
          *********************************
          DROP DOWN LIST
          *********************************
        -->
        <div class="ui-g-1 item-filtro" *ngIf="item.filterDataType === 'DROPDOWNLIST'">
          <p-dropdown
            [id]="item.fieldId"
            name="item.fieldId"
            [style]="{'width':'100%'}"
            [inputStyle]="{'width':'100%'}"
            tabindex="1"
            [(ngModel)]="item.itemSelected"
            [options]="item.dropDownOptions"
            [disabled]="!!item.disabled"
            [group]="!!item.dropDownGroup"
            [placeholder]="item.placeholder ? item.placeholder : item.fieldName"
            [autofocus]="true"
            [autoWidth]="true"
            [autoDisplayFirst]="!!item.autoDisplayFirst"
            [showClear]="!!item.showClear"
            (onChange)="dropDownOnChange($event, item, filtros)">
          </p-dropdown>
        </div>


        <!--
          *********************************
          AUTOCOMPLETE
          *********************************
        -->
        <div class="ui-g-2 item-filtro" *ngIf="item.filterDataType === 'AUTOCOMPLETE'">
          <span class="md-inputfield">
            <p-autoComplete
              [style]="{'width':'100%'}"
              [inputStyle]="{'width':'100%'}"
              [styleClass]="'autocompleteClass'"
              field="{{item.label}}"
              inputId="{{item.fieldId}}"
              [(ngModel)]="item.itemSelected"
              [inputStyleClass]="'autocompleteClass'"
              [suggestions]="item.resultset"
              [dropdown]="true"
              [size]="item.autocomplete.resultsetMaxSize"
              [forceSelection]="true"
              [required]="false"
              [disabled]="!!item.disabled"
              (completeMethod)="item.buscarItem($event)"
              (onSelect)="autocompleteOnSelectItem($event, item, filtros)"
              (onClear)="autocompleteOnClear(item, filtros)">
            </p-autoComplete>
            <label>{{item.fieldName}}</label>
          </span>
        </div>

        <!--
          *********************************
          DATA
          *********************************
        -->
        <div class="ui-g-1 item-filtro" *ngIf="item.filterDataType === 'DATA'">
          <span class="md-inputfield">
            <p-calendar
              [id]="item.fieldId"
              name="{{item.fieldName}}"
              [inputStyle]="{'width':'80%'}"
              [(ngModel)]="item.itemSelected"
              dateFormat="dd/mm/yy"
              readonlyInput="!!item.disabled"
              [disabled]="!!item.disabled"
              [showIcon]="true"
              showButtonBar="true"
              (ngModelChange)="dataOnChange($event, item, filtros)"></p-calendar>
              <!--
                selectionMode="range"
                [yearNavigator]="true"
                yearRange="1900:2030"
                [minDate]="minDate"
                (onSelect)="onSelectData($event, item, filtros)"
              -->
            <label>{{item.fieldName}}</label>
          </span>
        </div>





      </ng-template>
    </div>
  </div>
</div>

      <!-- <a *ngIf="item.visible"
          (click)="item.command($event)"
          title="{{item.title}}"
          style="cursor: pointer;">padding: 0 10px; margin: 0 10px;
        -->

      <!-- <i *ngIf="item.mat_icon" class="material-icons">{{item.mat_icon}}</i>
      <i *ngIf="item.fa_icon" class="{{item.fa_icon}}"></i>
      <span class="menuitem-badge" *ngIf="item.badge">{{item.badge}}</span>
      {{item.fieldName}} -->
